
const CardWrapper = ({  title, subtitle, children }) => {
  return (
    <div  className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
      {title && (
        <h2 className="text-base sm:text-lg font-semibold text-text-primary mb-2 font-poppins">
          {title}
        </h2>
      )}
      {subtitle && (
        <p className="text-xs sm:text-sm text-text-secondary mb-4">
          {subtitle}
        </p>
      )}
      {children}
    </div>
  );
};
export default CardWrapper;
